module.exports = __webpack_public_path__ + "static/media/stc.b7061419.svg";